import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';

const REDIRECT_COOLDOWN_MS = 10000;
const STORAGE_KEY = 'auth_redirect_ts';

export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const keycloak = inject(KeycloakService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401) {
        return throwError(() => error);
      }

      const lastRedirect = Number(sessionStorage.getItem(STORAGE_KEY) || 0);
      const now = Date.now();

      if (now - lastRedirect < REDIRECT_COOLDOWN_MS) {
        return throwError(() => error);
      }

      return from(keycloak.updateToken(0)).pipe(
        switchMap((refreshed) => {
          if (!refreshed) {
            sessionStorage.setItem(STORAGE_KEY, String(now));
            keycloak.login({ redirectUri: window.location.href });
            return throwError(() => error);
          }
          return next(req);
        }),
        catchError(() => {
          sessionStorage.setItem(STORAGE_KEY, String(now));
          keycloak.login({ redirectUri: window.location.href });
          return throwError(() => error);
        }),
      );
    }),
  );
};
